export const convertCentsPerKWhToDollars = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue / 100 : null;
};

export const getUniqueElectricRateOptions = (options = []) => {
  const uniqueOptions = [];
  const seen = new Set();

  options.forEach((option) => {
    if (!option?.region || !option?.buildingType) {
      return;
    }

    const key = `${option.region}::${option.buildingType}`;
    if (seen.has(key)) {
      return;
    }

    seen.add(key);
    uniqueOptions.push(option);
  });

  return uniqueOptions;
};

export const getEffectiveElectricRate = (electricRate, electricRateOptions = []) => {
  if (!electricRate) {
    return null;
  }

  if (
    electricRate?.manuallyEnteredRate !== null &&
    electricRate?.manuallyEnteredRate !== undefined
  ) {
    const manuallyEnteredRate = Number(electricRate.manuallyEnteredRate);
    return convertCentsPerKWhToDollars(manuallyEnteredRate);
  }

  const calculatedRate = Number(electricRate?.calculatedRate?.rate);
  if (Number.isFinite(calculatedRate)) {
    return convertCentsPerKWhToDollars(calculatedRate);
  }

  const matchingRateOption = electricRateOptions.find(
    (option) =>
      option.region === electricRate?.calculatedRate?.region &&
      option.buildingType === electricRate?.calculatedRate?.buildingType
  );
  const matchedRate = Number(matchingRateOption?.rate);

  return convertCentsPerKWhToDollars(matchedRate);
};
